<template>
	<transition name="dataLoading_fade">
		<div v-if="isFetching" class="DataLoading">
			<img src="@/assets/img/motion/loading.gif" alt="로티" loading="lazy" />
		</div>
	</transition>
</template>

<script setup lang="ts">
// api
import { useIsFetching } from '@tanstack/vue-query';

const isFetching = useIsFetching();
</script>

<style scoped lang="scss">
.DataLoading {
	z-index: 1000;
	position: fixed;
	top: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100vh;
	background-color: rgba(0, 0, 0, 0.3);
	img {
		width: 8rem;
	}
}

.pageLoading_fade-enter-active,
.pageLoading_fade-leave-active {
	transition: opacity 0.15s ease-out;
}
.pageLoading_fade-enter-from,
.pageLoading_fade-leave-to {
	opacity: 0;
}
</style>
